import { Typography } from '@one-thd/sui-atomic-components';
import { Filters } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { getWindow } from '../../../utils/general';
import { OrderFilterDrawer } from './OrderFilterDrawer';
export var OrderFilter = function () {
    var _a, _b, _c, _d;
    var _e = usePurchaseHistoryContext(), dateSelectorValue = _e.dateSelectorValue, pHRequest = _e.pHRequest;
    var phFilter = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem('PHFilter');
    var sessionPHFilter = phFilter ? JSON.parse(phFilter) : undefined;
    var _f = useState(false), isDrawerOpen = _f[0], setIsDrawerOpen = _f[1];
    var _g = useState({
        date: ((_c = sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) !== null && _c !== void 0 ? _c : dateSelectorValue) !== 'last6Months',
        user: ((_d = sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.userView) !== null && _d !== void 0 ? _d : pHRequest === null || pHRequest === void 0 ? void 0 : pHRequest.resultsFilter) !== 'allOrders',
    }), dateFilterDot = _g[0], setDateFilterDot = _g[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex sui-flex-col sui-items-center sui-cursor-pointer sui-ml-[12px] sui-relative", onClick: function () { return setIsDrawerOpen(true); }, role: "button", tabIndex: 0 },
            (dateFilterDot.date || dateFilterDot.user) && (React.createElement("div", { style: {
                    position: 'absolute',
                    top: '-2px',
                    left: '24px',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: 'rgb(249,99,2)',
                    zIndex: 100,
                } })),
            React.createElement(Filters, null),
            React.createElement(Typography, { color: "subtle" }, "Filter")),
        React.createElement(OrderFilterDrawer, { isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen, dateFilterDot: dateFilterDot, setDateFilterDot: setDateFilterDot })));
};
